<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps<{ orderId: string; createdAt?: string }>();
const reference = computed(() => props.orderId.replace(/^dr[_-]/, '').slice(0, 12));
const date = computed(() => {
  if (!props.createdAt || !Number.isFinite(Date.parse(props.createdAt))) return '';
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Paris',
  }).format(new Date(props.createdAt));
});
</script>

<template>
  <span class="order-reference" :title="orderId">
    <strong>Réf. {{ reference }}</strong>
    <span v-if="date">Commandée le {{ date }} (Paris)</span>
  </span>
</template>

<style scoped>
.order-reference {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.75rem;
  grid-column: 1 / -1;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #24364b;
  overflow-wrap: anywhere;
}
.order-reference strong {
  font-variant-numeric: tabular-nums;
}
</style>
